import { AppTitle } from 'shared/UI/UIKit/Title';
import { CurriculumHeader } from '../CurriculumHeader';
import { CurriculumBody } from '../CurriculumBody';
import { CurriculumFooter } from '../CurriculumFooter';
import styles from './styles.module.scss';

interface CurriculumTableProps {
  block: any;
}

export const CurriculumTable = ({ block }: CurriculumTableProps) => {
  const { title, headerRows, bodyRows, footerRows } = block || {};

  return (
    <div className={styles.wrapper}>
      <AppTitle className={styles.title} level={3}>
        {title || 'Учебный план'}
      </AppTitle>
      <table className={styles.table}>
        {headerRows && <CurriculumHeader rows={headerRows} />}
        {bodyRows && <CurriculumBody rows={bodyRows} />}
        {footerRows && <CurriculumFooter rows={footerRows} />}
      </table>
    </div>
  );
};
